export default "__VITE_ASSET__DsUfc51t__"